/**
 * Scans that ended badly, reported to Paige so paige-watch and support see them (docs/runbooks/scan-client.md,
 * section 7). The package owns no API client: the app installs a reporter with `setScanProblemReporter` (it
 * posts to /v1/client-errors as kind `scanner`, logged as `scanner_error`). The report names the scanner, the
 * driver layer, the outcome, the pages kept and the driver's codes; never an image, a page's content or a
 * file name.
 */
export interface ScanProblem {
  outcome: string;
  scanner: string;
  layer?: string | undefined;
  pages: number;
  agent?: string | undefined;
  detail?: string | undefined;
}

export type ScanProblemReporter = (message: string) => void;

let reporter: ScanProblemReporter | null = null;

export function setScanProblemReporter(report: ScanProblemReporter | null): void {
  reporter = report;
}

/** The one line support reads: outcome, layer, scanner, pages kept, agent version, driver detail. */
export function describeScanProblem(problem: ScanProblem): string {
  const parts = [
    problem.outcome,
    problem.layer ?? 'unknown',
    JSON.stringify(problem.scanner.slice(0, 80)),
    `after ${problem.pages} page${problem.pages === 1 ? '' : 's'}`,
    problem.agent ? `Paige Scan ${problem.agent}` : null,
  ].filter(Boolean);
  return `${parts.join(' ')}${problem.detail ? `: ${problem.detail.slice(0, 240)}` : ''}`;
}

/** Sends the report; nothing happens without a reporter, and a reporter that throws never breaks the scan. */
export function reportScanProblem(problem: ScanProblem): void {
  if (!reporter) return;
  try {
    reporter(describeScanProblem(problem));
  } catch {
    // Reporting never breaks the flow it observes.
  }
}
